var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyWishlistHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 170,
    viewBox: "0 0 171 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 85,
    r: 85,
    fill: "#F0F9F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9787 63.4601C79.7557 56.2079 69.3785 54.2571 61.5815 60.8979C53.7845 67.5387 52.6868 78.6419 58.8098 86.496C63.9007 93.0262 79.3074 106.799 84.3569 111.257C84.9218 111.755 85.2043 112.005 85.5338 112.103C85.8214 112.188 86.136 112.188 86.4236 112.103C86.7531 112.005 87.0355 111.755 87.6005 111.257C92.65 106.799 108.057 93.0262 113.148 86.496C119.271 78.6419 118.307 67.4689 110.376 60.8979C102.445 54.3269 92.2017 56.2079 85.9787 63.4601Z",
    stroke: "#2196F3",
    strokeWidth: 6.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWishlistHeart);
export default __webpack_public_path__ + "static/media/empty-wishlist-heart.5090263af65cb29772af26ef4447ac1e.svg";
export { ForwardRef as ReactComponent };